import React, { useState } from "react";
import RenderButton from "../common/button";

const Headder = ({ onChange, disabled }) => {
  const [report1, setReport1] = useState("btn btn-primary");
  const [report2, setReport2] = useState("btn btn-outline-dark");
  const [report3, setReport3] = useState("btn btn-outline-dark");
  const [report4, setReport4] = useState("btn btn-outline-dark");

  const handleonClick = ({ currentTarget: input }) => {
    if (input.value == 1) {
      disabledlabel();
      setReport1("btn btn-primary");
    } else if (input.value == 2) {
      disabledlabel();
      setReport2("btn btn-primary");
    } else if (input.value == 3) {
      disabledlabel();
      setReport3("btn btn-primary");
    } else if (input.value == 4) {
      disabledlabel();
      setReport4("btn btn-primary");
    }
    onChange(input.value);
  };
  // const handleChange = (date) => {
  //     setStartDate(date)
  //     handleDateChange(date);
  // }

  const disabledlabel = () => {
    setReport1("btn btn-outline-dark");
    setReport2("btn btn-outline-dark");
    setReport3("btn btn-outline-dark");
    setReport4("btn btn-outline-dark");
  };

  return (
  
      <div className="row">
        <div className="col-auto mb-1 px-0 ">
          <RenderButton
            disabled={disabled}
            label="รายการลงสินค้า"
            value="1"
            onClick={handleonClick}
            className={report1}
          />
          <RenderButton
            disabled={disabled}
            value="2"
            label="ปริมาณรถตามช่วงเวลา"
            onClick={handleonClick}
            className={report2}
          />
          <RenderButton
            disabled={disabled}
            value="3"
            label="การใช้งานจักกลหนัก"
            onClick={handleonClick}
            className={report3}
          />
          <RenderButton
            disabled={disabled}
            value="4"
            label="สรุปผลงานโรงชิพ"
            onClick={handleonClick}
            className={report4}
          />
        </div>
      </div>
   
  );
};

export default Headder;
